import { render, staticRenderFns } from "./answerDownload.vue?vue&type=template&id=b416f690&scoped=true"
import script from "./answerDownload.vue?vue&type=script&lang=js"
export * from "./answerDownload.vue?vue&type=script&lang=js"
import style0 from "./answerDownload.vue?vue&type=style&index=0&id=b416f690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b416f690",
  null
  
)

export default component.exports